export default __webpack_public_path__ + "static/media/SelfMonitoringLogo.b2fcee8b.svg";